<template>
    <div class="col-xl-4 col-sm-6 box-col-30">
        <div class="card top-products">
            <div class="card-header pb-0">
                <h3>Top Products</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive theme-scrollbar">
                    <table class="table table-bordernone">
                        <tbody>
                            <tr v-for="item in data" :key="item">
                                <td>
                                    <div class="d-flex">
                                        <div class="flex-shrink-0">
                                            <div class="icon"><img class="img-fluid" :src="getImageUrl(item.img)"
                                                    alt="chair"></div>
                                        </div>
                                        <div class="flex-grow-1"><router-link to="/ecommerce/product/page/1">
                                                <h5>{{ item.name }}</h5>
                                            </router-link>
                                            <p>{{ item.items }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <h5>{{ item.code }}</h5>
                                    <p>{{ item.pix }}</p>
                                </td>
                                <td class="text-center"> <i class="flag-icon " :class="item.flg"></i></td>
                                <td>
                                    <h5>{{ item.total }}</h5>
                                    <p>{{ item.price }} </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import getImage from "@/mixins/getImage"
import tables from "@/data/tables"
export default {
    name: 'topproductPage',
    mixins: [getImage],
    data() {
        return {
            data: tables.top
        }
    }
}
</script>
